import { getAvailableVideoType, getFullAccessActionName, canPlayFullOrPreview } from 'widget/ui-selectors/video-access';

import getTranslationData from './translation-data';
import getCallbackFromProps from './callback';


export default function getPlayButtonConfig(props) {
  const { channelData, videoItem, currentSiteUser } = props;

  const availableVideoType = getAvailableVideoType(channelData, videoItem, currentSiteUser);
  const fullAccessAction = getFullAccessActionName(channelData, videoItem, currentSiteUser);

  const callback = getCallbackFromProps(
    props,
    canPlayFullOrPreview(channelData, videoItem, currentSiteUser),
    fullAccessAction
  );

  const translationData = getTranslationData(availableVideoType, fullAccessAction);

  if (translationData) {
    return {
      callback,
      translationData,
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/play/button-config.js